export const AskAISkeleton = () => {
  return (
    <div className="flex flex-col gap-4 animate-pulse">
      {/* Title/Header section */}
      <div className="flex gap-2 items-center">
        <div className="w-6 h-6 bg-gradient-to-r from-[#a5f3fc40] to-[#e9d5ff40] rounded-full" />
        <div className="flex gap-2">
          <div className="w-24 h-4 bg-gradient-to-r from-[#a5f3fc40] to-[#e9d5ff40] rounded" />
          <div className="w-48 h-4 bg-gradient-to-r from-[#a5f3fc40] to-[#e9d5ff40] rounded" />
        </div>
      </div>

      {/* Content section */}
      <div className="flex flex-col gap-3">
        {/* First paragraph */}
        <div className="flex flex-col gap-2">
          <div className="w-full h-2 bg-gradient-to-r from-[#a5f3fc40] to-[#e9d5ff40] rounded" />
          <div className="w-3/4 h-2 bg-gradient-to-r from-[#a5f3fc40] to-[#e9d5ff40] rounded" />
          <div className="flex gap-2">
            <div className="w-3/6 h-2 bg-gradient-to-r from-[#a5f3fc40] to-[#e9d5ff40] rounded-full" />
            <div className="w-1/6 h-2 bg-gradient-to-r from-[#a5f3fc40] to-[#e9d5ff40] opacity-50 rounded" />
            <div className="w-2/6 h-2 bg-gradient-to-r from-[#a5f3fc40] to-[#e9d5ff40] rounded-full" />
          </div>
        </div>

        {/* List items */}
        <div className="flex flex-col gap-2 mt-2">
          <div className="flex gap-2">
            <div className="w-4 h-2 bg-gradient-to-r from-[#a5f3fc40] to-[#e9d5ff40] rounded-full" />
            <div className="w-5/6 h-2 bg-gradient-to-r from-[#a5f3fc40] to-[#e9d5ff40] rounded" />
          </div>
          <div className="flex gap-2">
            <div className="w-4 h-2 bg-gradient-to-r from-[#a5f3fc40] to-[#e9d5ff40] rounded-full" />
            <div className="w-3/6 h-2 bg-gradient-to-r from-[#a5f3fc40] to-[#e9d5ff40] rounded" />
          </div>
          <div className="flex gap-2">
            <div className="w-4 h-2 bg-gradient-to-r from-[#a5f3fc40] to-[#e9d5ff40] rounded-full" />
            <div className="w-4/6 h-2 bg-gradient-to-r from-[#a5f3fc40] to-[#e9d5ff40] rounded" />
          </div>
          <div className="flex gap-2">
            <div className="w-4 h-2 bg-gradient-to-r from-[#a5f3fc40] to-[#e9d5ff40] rounded-full" />
            <div className="w-3/4 h-2 bg-gradient-to-r from-[#a5f3fc40] to-[#e9d5ff40] rounded" />
          </div>
        </div>
      </div>
    </div>
  )
}
